import React from 'react';

export const ApiContext = React.createContext<undefined>(undefined);
